import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "@commerce-core/react-components/styles.css";
import { LinkEnhancer } from "@commerce-core/react-components";
import App from "@/App";

const rootElement = document.getElementById("react-app");

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <LinkEnhancer>
        <App />
      </LinkEnhancer>
    </StrictMode>,
  );
}
